import {BaseModel, IBaseModel} from '../base.model'

export interface IEquipment extends IBaseModel {
  name?: string;
  description?: string;
  brand?: string;
  reference?: string;
  location?: string;
  number_equipment?: number;
  contractors_assigned?: any[];
  disable?: boolean;
  fk_equipment_block?: number;
  fk_equipment_apartment?: number;
  fk_character_problem_lvl1?: number;
  fk_character_problem_lvl2?: number;
  acquisition_date?: string;
  block?: any;
  apartment?: any;
  attributes?: any[];
  category?: any;
  subcategory?: any;
  // picture?: string;
}

export class EquipmentDto extends BaseModel implements IEquipment {
  name?: string
  description?: string
  brand?: string
  reference?: string
  location?: string
  number_equipment?: number
  contractors_assigned?: any[]
  disable?: boolean
  fk_equipment_block?: number
  fk_equipment_apartment?: number
  fk_character_problem_lvl1?: number
  fk_character_problem_lvl2?: number
  acquisition_date?: string
  block?: any
  apartment?: any
  attributes?: any[]
  category?: any
  subcategory?: any
  // picture?: string;

  constructor(opt: IEquipment) {
    super(opt);
    this.name = opt.name || null
    this.description = opt.description || null
    this.brand = opt.brand || null
    this.reference = opt.reference || null
    this.location = opt.location || null
    this.number_equipment = opt.number_equipment || null
    this.contractors_assigned = opt.contractors_assigned || []
    this.disable = opt.disable || false
    this.fk_equipment_block = opt.fk_equipment_block || null
    this.fk_equipment_apartment = opt.fk_equipment_apartment || null
    this.fk_character_problem_lvl1 = opt.fk_character_problem_lvl1 || null
    this.fk_character_problem_lvl2 = opt.fk_character_problem_lvl2 || null
    this.acquisition_date = opt.acquisition_date || null
  }

  compareChanges(newVal: IEquipment) {
    let EqpKey: IEquipment = new EquipmentDto({})
    let changes = {}
    for (let key in EqpKey) {
      if (key === 'contractors_assigned') {
        if (!(this[key].length === newVal[key].length && this[key].every((value, index) => value === newVal[key][index])))
          changes[key] = newVal[key]
      } else if (this[key] !== newVal[key]) changes[key] = newVal[key]
    }
    return changes
  }
}



// WEBPACK FOOTER //
// ./src/models/equipment/equipment.model.ts